module.exports = __webpack_public_path__ + "static/media/Inter.var.8dd26c3d.woff2";